import React from 'react';
import { Typography } from '@mui/material';
import { jwtDecode } from 'jwt-decode';

function UserDashboard() {


     const token = "true";//localStorage.getItem('token');
    
      let userfullname = 'admin user!!!!!';
      if (token) {
        try {
        //  const decoded = jwtDecode(token);
         // userfullname = decoded.userfullname;
        } catch (e) {
          console.error('Invalid token', e);
        }
      }

      
  return <Typography variant="h5">Welcome User <strong>{userfullname}</strong> 🙋‍♂️</Typography>;
  
}

export default UserDashboard;
